import React from 'react';
import { useNavigate, Link, Routes, Route } from 'react-router-dom';
import SettingsPage from '../pages/SettingsPage';
import IconHome from '../assets/icon-home.png';
import IconCog from '../assets/icon-cog.png';
import IconLogout from '../assets/SMALL_LOGOUT.png';

import { useAuth } from '../utils/authprovider'


import '../styles/SideMenu.css';

const SideMenu = ({ userId }) => {
  const navigate = useNavigate()
  const { logout } = useAuth()

  const handleLogout = async e => {
    e.preventDefault()
    await logout()                // ← clears isAuthenticated
    navigate("/signin")
  }

  return (
    <div className="dashboard-side-menu">
      <Routes>
        <Route path="/settings" element={<SettingsPage />} />
      </Routes>
      <a href={`/dashboard/${userId}`} className="dashboard-side-menu-item">
        <img className="dashboard-small-icon" src={IconHome} alt="Home" />
      </a>
      <Link to={`/settings/${userId}`} className="dashboard-side-menu-item">
        <img className="dashboard-small-icon" src={IconCog} alt="Settings" />
      </Link>
      <button 
        type="button" 
        onClick={handleLogout} 
        className="dashboard-side-menu-item" 
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
      >
        <img className="dashboard-small-icon" src={IconLogout} alt="Logout" />
      </button>
    </div>
  );
};

export default SideMenu;